<div class="d-flex user-info" (click)="onClicked()">
    <div class="m-2 avatar">
        <one-avatar size="32" [imageUrl]="user.avatarUrl"></one-avatar>
    </div>
    <div class="m-2 info  flex-grow-1">
        <div class="name">
            {{user.fullName}}
        </div>
        <div class="title">
            {{title}}
        </div>
    </div>
    <div class="m-2 approval-status" *ngIf="showApprovalStatus && user.approvalStatus">
        <mat-icon [class]="user.approvalStatus">{{approvalStatusIcon}}</mat-icon>
    </div>
    <div class="m-2 options" *ngIf="showOption">
        <div class="option" (click)="onRemove()">Xóa</div>
    </div>
</div>